import { GEE_IMAGE_API_BASE_URL } from "src/environments/environment.prod";
import { Basemap } from "../types";

export const MOD_VISUALIZATION_BASEMAPS: Basemap[] = [
  {
    name: 'Satellite',
    isVisible: true,
    getLayer: () => ({
      source: {
        type: 'raster',
        tiles: ['https://mt1.google.com/vt/lyrs=s&hl=en&x={x}&y={y}&z={z}'],
        tileSize: 256
      },
      layer: {
        id: 'satellite-basemap-layer',
        type: 'raster',
        source: 'satellite-basemap-source'
      }
    })
  },
  {
    name: 'Open Street',
    isVisible: false,
    getLayer: () => ({
      source: {
        type: 'raster',
        tiles: ['https://a.tile.openstreetmap.org/{z}/{x}/{y}.png'],
        tileSize: 256
      },
      layer: {
        id: 'open street-basemap-layer',
        type: 'raster',
        source: 'open street-basemap-source'
      }
    })
  },
  {
    name: 'Google Street',
    isVisible: false,
    getLayer: () => ({
      source: {
        type: 'raster',
        tiles: ['https://mt1.google.com/vt/lyrs=h&x={x}&y={y}&z={z}'],
        tileSize: 256
      },
      layer: {
        id: 'google street-basemap-layer',
        type: 'raster',
        source: 'google street-basemap-source'
      }
    })
  },
  {
    name: 'MapBiomas (2022)',
    isVisible: false,
    getLayer: () => ({
      source: {
        type: 'raster',
        tiles: ['http://azure.solved.eco.br:8080/geoserver/solved/wms?service=WMS&version=1.1.0&request=GetMap&layers=solved%3Amapbiomas_brazil_2023&bbox={bbox-epsg-3857}&width=750&height=768&srs=EPSG%3A3857&format=image/png'],
        tileSize: 256
      },
      layer: {
        id: 'mapbiomas (2022)-basemap-layer',
        type: 'raster',
        source: 'mapbiomas (2022)-basemap-source'
      }
    })
  },
  // {
  //   name: 'Mosaico Planet NICFI',
  //   isVisible: false,
  //   getLayer: () => ({
  //     source: {
  //       type: 'raster',
  //       tiles: [`${GEE_IMAGE_API_BASE_URL}/planet/{z}/{x}/{y}?year=2022&month=12`],
  //       tileSize: 256
  //     },
  //     layer: {
  //       id: 'mosaico planet nicfi-basemap-layer',
  //       type: 'raster',
  //       source: 'mosaico planet nicfi-basemap-source'
  //     }
  //   })
  // },
  {
    name: 'Escuro',
    isVisible: false,
    getLayer: () => ({
      source: {
        type: 'raster',
        tiles: ['https://a.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}.png'],
        tileSize: 256
      },
      layer: {
        id: 'escuro-basemap-layer',
        type: 'raster',
        source: 'escuro-basemap-source'
      }
    })
  }
]
